import { makeAgendaItem } from "../features/insights/agenda/agenda.utils";
import { AGENDA_STATE } from "../features/insights/agenda/agenda.constants";

export const AimsAvailabilityApiResponse = {
  result: "AimsAvailable",
  message: "low_risk",
  hasPandC: false,
  warningFromZoom: null,
  warningFromOutlook: null,
  hasExternalUser: false,
  summaryButtonFor: "mznwng@amazon.com",
  alias: "mznwng",
  role: "host",
  meetingUuid: "TUHHpXOIQRe5wt5XANnFjA=="
};

const STRUCTURED_SUMMARY_SAMPLE = {
  sections: [
    { type: "overview", format: "text", content: "The meeting discussed the introduction of Bedrock agents to support complex workflows involving multiple agents working in parallel and sharing information." },
    { type: "narrative", format: "markdown", content: "The team addressed customer feedback regarding the complexity of managing multiple agents across various tasks. They introduced the concept of **Bedrock agents**, which include a supervisor agent to manage and coordinate specialized agents. An example involving Moody's use of this technology for financial risk analysis was presented to illustrate the benefits." },
    { type: "decisions", format: "list", title: "Decisions", items: ["Announce the support of Bedrock agents for managing complex workflows.", "Implement a supervisor agent to coordinate and manage interactions between specialized agents."] },
    { type: "nextSteps", format: "list", title: "Next Steps", items: ["Develop the Bedrock agent framework.", "Test the multi-agent collaboration system with Moody's for financial risk alerts.", "Create documentation and guidelines for using Bedrock agents in complex workflows."] },
  ]
};

export const sampleSummaryList = [
  {
    "meetingTitle": "[Normal meeting] Lu Test",
    "summaryType": "low_risk",
    "role": "host",
    "meetingStartTime": 1748984400,
    "meetingEndTime": 1748986200,
    "summaryHighlight": "This is summaryHighlight",
    "originalSummary": "The meeting discussed the introduction of Bedrock agents...",
    "conciseOverview": "The meeting discussed the introduction of Bedrock agents to support complex workflows involving multiple agents working in parallel and sharing information.",
    "narrativeSummary": "The team addressed customer feedback regarding the complexity of managing multiple agents across various tasks.",
    "structuredSummary": STRUCTURED_SUMMARY_SAMPLE,
    "decisions": ["Announce the support of Bedrock agents for managing complex workflows.", "Implement a supervisor agent to coordinate and manage interactions between specialized agents."],
    "nextSteps": ["Develop the Bedrock agent framework.", "Test the multi-agent collaboration system with Moody's for financial risk alerts.", "Create documentation and guidelines for using Bedrock agents in complex workflows."],
    "attendeeNameList": "Adrian David,Feng Shan,Lu Wang,Tianlei Xu,Tong Zhang,TestLastName verylongname-verylongname,",
    "attendees": [
      { "displayName": "Test Alpha", "alias": "testa", "email": "test.alpha@example.com", "title": "Test Engineer", "external": false, "joined": true, "adHoc": false },
      { "displayName": "Test Beta", "alias": "testb", "email": "test.beta@example.com", "title": "Senior Test Engineer II", "external": false, "joined": true, "adHoc": false },
      { "displayName": "Test Gamma", "alias": "testg", "email": "test.gamma@example.com", "title": "Test Manager", "external": false, "joined": false, "adHoc": false },
      { "displayName": "Test Delta", "alias": "testd", "email": "test.delta@example.com", "title": "", "external": false, "joined": true, "adHoc": true },
      { "displayName": "Test Verylongfirstname Verylonglastname-Verylonglastname", "alias": "testvln", "email": "test.vln@example.com", "title": "Principal Test Product Manager", "external": false, "joined": false, "adHoc": false },
      { "displayName": "Fake External One", "alias": null, "email": "fake.one@example-partner.com", "title": "", "external": true, "joined": true, "adHoc": false },
      { "displayName": "Fake External Two", "alias": null, "email": "fake.two-with-a-very-long-email@external-company-example.com", "title": "", "external": true, "joined": false, "adHoc": true }
    ],
    "timeZone": "PST",
    "meetingDateAndTime": "Tue, June 3 | 02:00 PM - 02:30 PM PDT",
    "meetingUuid": "ttoXAEsJRpCpe9+bRgUCig==",
    "feedback": null,
    "feedbackReason": null,
    "feedbackComment": null,
    "feedbackTimestamp": null,
    "aimsUuid": "00001"
  },
  {
    "meetingTitle": "[attorney_in_attendance] Attendee contains attorney Test",
    "summaryType": "attorney_in_attendance",
    "iconType": "warning",
    "role": "host",
    "meetingStartTime": 1748984400,
    "meetingEndTime": 1748986200,
    "summaryHighlight": "This is summaryHighlight",
    "structuredSummary": STRUCTURED_SUMMARY_SAMPLE,
    "conciseOverview": "The meeting discussed the introduction of Bedrock agents to support complex workflows.",
    "narrativeSummary": "The team addressed customer feedback regarding the complexity of managing multiple agents across various tasks.",
    "decisions": ["Announce the support of Bedrock agents for managing complex workflows.", "Implement a supervisor agent to coordinate and manage interactions between specialized agents."],
    "nextSteps": ["Develop the Bedrock agent framework.", "Test the multi-agent collaboration system with Moody's for financial risk alerts."],
    "attendeeNameList": "Adrian David,Feng Shan,Lu Wang,Tianlei Xu,Tong Zhang,",
    "timeZone": "PST",
    "meetingDateAndTime": "Tue, June 3 | 02:00 PM - 02:30 PM PDT",
    "meetingUuid": "ttoXAEsJRpCpe9+bRgUCig==",
    "feedback": null,
    "feedbackReason": null,
    "feedbackComment": null,
    "feedbackTimestamp": null,
    "aimsUuid": "00001"
  },
  {
    "meetingTitle": "[server_error] Lu Test",
    "summaryType": "server_error",
    "iconType": "error",
    "role": "host",
    "meetingStartTime": 1748984400,
    "meetingEndTime": 1748986200,
    "summaryHighlight": "There is no meeting summary because there were issues with the server.",
    "attendeeNameList": "Lu Wang,",
    "timeZone": "PST",
    "meetingDateAndTime": "Tue, June 3 | 02:00 PM - 02:30 PM PDT",
    "meetingUuid": "ttoXAEsJRpCpe9+bRgUCig==",
    "feedback": null,
    "feedbackReason": null,
    "feedbackComment": null,
    "feedbackTimestamp": null,
    "aimsUuid": "00002"
  },
  {
    "meetingTitle": "[P&C deprecated] P&C Lu is host",
    "role": "host",
    "meetingStartTime": 1748984400,
    "meetingEndTime": 1748986200,
    "summaryType": "privileged_and_confidential",
    "structuredSummary": STRUCTURED_SUMMARY_SAMPLE,
    "conciseOverview": "The meeting discussed the introduction of Bedrock agents.",
    "attendeeNameList": "Lu Wang,",
    "timeZone": "PST",
    "meetingDateAndTime": "Tue, June 3 | 02:00 PM - 02:30 PM PDT",
    "meetingUuid": "ttoXAEsJRpCpe9+bRgUCig==",
    "feedback": null,
    "feedbackReason": null,
    "feedbackComment": null,
    "feedbackTimestamp": null,
    "aimsUuid": "2ce530b329b6493fac742c88cea7aa7b"
  },
  {
    "meetingTitle": "[P&C deprecated] P&C Lu is attendee",
    "role": "attendee",
    "meetingStartTime": 1748984400,
    "meetingEndTime": 1748986200,
    "summaryType": "privileged_and_confidential",
    "structuredSummary": STRUCTURED_SUMMARY_SAMPLE,
    "conciseOverview": "The meeting discussed the introduction of Bedrock agents.",
    "attendeeNameList": "Lu Wang,",
    "timeZone": "PST",
    "meetingDateAndTime": "Tue, June 3 | 02:00 PM - 02:30 PM PDT",
    "meetingUuid": "ttoXAEsJRpCpe9+bRgUCig==",
    "feedback": null,
    "feedbackReason": null,
    "feedbackComment": null,
    "feedbackTimestamp": null,
    "aimsUuid": "2ce530b329b6493fac742c88cea7aa7b"
  },
  {
    "meetingTitle": "[Short Meeting] Lu Wang's Personal Meeting Room",
    "summaryType": "short_meeting",
    "iconType": "error",
    "meetingStartTime": 1748461584,
    "meetingEndTime": 1748461797,
    "summaryHighlight": "There is no meeting summary because the organizer turned on meeting summarization for less than 2 minutes.",
    "attendeeNameList": "Lu Wang,",
    "timeZone": "PST",
    "meetingDateAndTime": "Wed, May 28 | 12:46 PM - 12:49 PM PDT",
    "meetingUuid": "8GaQ3Pw7RESvYwtjeMcgOg==",
    "feedback": null,
    "feedbackReason": null,
    "feedbackComment": null,
    "feedbackTimestamp": null,
    "aimsUuid": "20841bb9221644eeab1688a7bdf88f83"
  },
  {
    meetingTitle: "[investigation] Wang, Lu's Personal Meeting Room",
    summaryType: "investigation",
    iconType: "error",
    aimsUuid: "111",
    role: "host",
    meetingStartTime: 1748291782,
    meetingEndTime: 1748462391,
    summaryHighlight: "The meeting discussed advancements in AWS's AI and generative AI capabilities.",
    attendeeNameList: "Lu Wang,",
    meetingDateAndTime: "Sun, May 26 | 09:54 AM - 10:00 AM PDT",
    meetingUuid: "someGeneratedUuidHere==",
    feedback: null,
    feedbackReason: null,
    feedbackComment: null,
    feedbackTimestamp: null,
  },
  {
    meetingTitle: "[Test2] Wang, Lu's Personal Meeting Room",
    summaryType: "low_risk",
    aimsUuid: "222",
    role: "host",
    meetingStartTime: 1748118982,
    meetingEndTime: 1748462391,
    structuredSummary: STRUCTURED_SUMMARY_SAMPLE,
    summaryHighlight: "The meeting discussed advancements in AWS's AI and generative AI capabilities.",
    conciseOverview: "The meeting discussed advancements in AWS's AI and generative AI capabilities.",
    attendeeNameList: "Lu Wang,",
    meetingDateAndTime: "Sat, May 24 | 09:54 AM - 10:00 AM PDT",
    meetingUuid: "someGeneratedUuidHere==",
    feedback: null,
    feedbackReason: null,
    feedbackComment: null,
    feedbackTimestamp: null,
  },
  {
    meetingTitle: "[hr_complaint] Test meeting",
    summaryType: "hr_complaint",
    iconType: "error",
    role: "host",
    aimsUuid: "333",
    meetingStartTime: 1748462048,
    meetingEndTime: 1748462391,
    summaryHighlight: "The meeting discussed advancements in AWS's AI and generative AI capabilities.",
    attendeeNameList: "Lu Wang,",
    meetingDateAndTime: "Mon, May 27 | 09:54 AM - 10:00 AM PDT",
    meetingUuid: "someGeneratedUuidHere==",
    feedback: null,
    feedbackReason: null,
    feedbackComment: null,
    feedbackTimestamp: null,
  },
  {
    meetingTitle: "[performance_review] Test 4",
    summaryType: "performance_review",
    iconType: "error",
    aimsUuid: "444",
    role: "host",
    meetingStartTime: 1748462048,
    meetingEndTime: 1748462391,
    summaryHighlight: "The meeting discussed advancements in AWS's AI and generative AI capabilities.",
    attendeeNameList: "Lu Wang,",
    meetingDateAndTime: "Mon, May 27 | 09:54 AM - 10:00 AM PDT",
    meetingUuid: "someGeneratedUuidHere==",
    feedback: null,
    feedbackReason: null,
    feedbackComment: null,
    feedbackTimestamp: null,
  },
];

// parseCustomBlocks treats every card type except mention/section as external-only,
// so these render as cards only for a reply attributed to an extension. Under the
// built-in agent they fall through to their raw JSON body.
export const sampleCustomBlocksResponse = `Here's a demo of all streaming card types:

\`\`\`metric_card
{"title":"Sprint Metrics","rows":[{"label":"Velocity","value":"42 pts","trend":"up"},{"label":"Bug Count","value":"3","trend":"down"},{"label":"Coverage","value":"87%","trend":"flat"}],"alert":"Coverage dropped below 90% target"}
\`\`\`

\`\`\`action_list
{"title":"Action Items","items":[{"text":"Submit PR for auth refactor","priority":"high"},{"text":"Update API docs","priority":"medium"},{"text":"Schedule design review","priority":"low"}]}
\`\`\`

\`\`\`alert_banner
{"message":"Deploy freeze starts tomorrow at 5PM PST","severity":"warning","dismissible":true}
\`\`\`

\`\`\`alert_banner
{"message":"Pipeline build completed successfully","severity":"info","dismissible":false}
\`\`\`

\`\`\`alert_banner
{"message":"Production deployment failed - rollback initiated","severity":"critical","dismissible":false}
\`\`\`

\`\`\`timeline
{"title":"Release Timeline","events":[{"time":"Mon 9am","label":"Code freeze","status":"done","description":"All feature branches merged"},{"time":"Tue 2pm","label":"QA sign-off","status":"active","description":"Running integration tests"},{"time":"Wed 10am","label":"Prod deploy","status":"pending","description":"Deploy to us-east-1 first"}]}
\`\`\`

\`\`\`status_table
{"title":"Service Health","headers":["Service","Status","Latency"],"rows":[["Auth","Healthy","12ms"],["Payments","Degraded","450ms"],["Search","Healthy","28ms"]],"highlightRows":[1]}
\`\`\`

\`\`\`collapsible
{"title":"Error Details","summary":"RequestTimeout from payments-service at 14:32 UTC","detail":"The payments-service upstream returned HTTP 504 after 30s. Root cause: connection pool exhaustion due to a burst of retry traffic from the mobile client after a network blip."}
\`\`\`

\`\`\`comparison
{"title":"Migration Options","optionA":{"label":"Option A: In-place","points":["No downtime","Risk of data corruption","2 days effort"]},"optionB":{"label":"Option B: Blue-green","points":["Zero risk","Requires double infra","5 days effort"]}}
\`\`\`

\`\`\`code_diff
{"title":"Fix: null check","before":"const name = user.profile.name;","after":"const name = user?.profile?.name ?? 'Unknown';"}
\`\`\`

\`\`\`link_card
{"url":"https://w.amazon.com/bin/view/Example","title":"Design Doc: Agent Platform","description":"Full architecture and API contracts","type":"wiki"}
\`\`\`

\`\`\`link_card
{"url":"https://sim.amazon.com/issues/SIM-12345","title":"SIM-12345: Auth timeout in prod","description":"P2 - Assigned to Bob, opened 2h ago","type":"sim"}
\`\`\`

\`\`\`link_card
{"url":"https://code.amazon.com/reviews/CR-123456","title":"CR-123456: Add retry logic","description":"3 files changed, 2 approvals needed","type":"cr"}
\`\`\`

\`\`\`link_card
{"url":"https://docs.amazon.com/api/guide","title":"API Integration Guide","description":"Step-by-step setup for builder agents","type":"doc"}
\`\`\`

\`\`\`link_card
{"url":"https://example.com/external-resource","title":"External Resource","description":"Third-party documentation reference","type":"link"}
\`\`\`

\`\`\`callout
{"type":"tip","title":"Pro tip","content":"Use extensionId to route messages — never send endpoint ARNs from the client."}
\`\`\`

\`\`\`callout
{"type":"note","title":"Note","content":"Visibility is immutable after first publish — remove and re-publish with new contentId to change."}
\`\`\`

\`\`\`callout
{"type":"warning","title":"Warning","content":"This CR has been open for 7 days without review."}
\`\`\`

\`\`\`callout
{"type":"important","title":"Action Required","content":"Production certificate expires in 48 hours — renew immediately."}
\`\`\`

\`\`\`progress_indicator
{"label":"Migration Progress","current":7,"max":12,"unit":"services"}
\`\`\`

That covers all the card types! Let me know if you want to see any specific one in more detail.`;

export const sampleMixedResponse = `Here's a quick status update on the sprint:

## Current Sprint Health

The team is on track for the **Q3 release**, but there are a few areas that need attention.

\`\`\`metric_card
{"title":"Sprint Metrics","rows":[{"label":"Velocity","value":"42 pts","trend":"up"},{"label":"Bug Count","value":"3","trend":"down"},{"label":"Coverage","value":"87%","trend":"flat"}],"alert":"Coverage dropped below 90% target"}
\`\`\`

### Key Blockers

We identified two main blockers:

1. **Auth service timeout** — p99 latency spiked after last deploy
2. **Missing API docs** — external team can't integrate without them

\`\`\`action_list
{"title":"Action Items","items":[{"text":"Investigate auth timeout root cause","priority":"high"},{"text":"Write API docs for v2 endpoints","priority":"medium"},{"text":"Update staging environment","priority":"low"}]}
\`\`\`

\`\`\`callout
{"type":"warning","title":"Warning","content":"Deploy freeze starts Friday — all PRs must be merged by EOD Thursday."}
\`\`\`

### Long-token wrapping checks

Bare unbroken run of characters:

xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

A long URL with no spaces: https://code.amazon.com/packages/UCAimsWebApp/blobs/mainline/--/src/features/assistant/agentic/markdownComponents.jsx?reallyLongQueryParameter=someValueThatKeepsGoing

An identifier inside a list item:

- Stream id: \`arn:aws:bedrock:us-east-1:123456789012:agent-alias/ABCDEFGHIJ/KLMNOPQRSTUVWXYZ0123456789\`
- Normal item that should wrap at word boundaries the way it always has, with enough text to take more than one line

A **long token inside bold text**: supercalifragilisticexpialidociousandthensomemoretexttopushitwellpastthepanelwidth

> A blockquote holding an unbreakable string: aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa

A fenced code block should scroll sideways rather than wrap mid-token:

\`\`\`javascript
const result = await someService.invokeWithAVeryLongMethodName({ parameterOne: "value", parameterTwo: "anotherValue", parameterThree: 42 });
\`\`\`

Let me know if you want more details on any of these items.`;

export const sampleMarkdownResponse = `Here's a summary of today's meeting:

## Key Discussion Points

The team discussed **three major topics** during the sync:

1. **Authentication refactor** — moving from session-based to *token-based* auth
2. **Performance improvements** — reducing p99 latency from 450ms to under 200ms
3. **Q3 planning** — aligning on priorities for next quarter

### Technical Details

We decided to use \`JWT\` tokens with a 15-minute expiry. The implementation will follow this pattern:

\`\`\`javascript
const token = await auth.generateToken(user, { expiresIn: '15m' });
\`\`\`

### Comparison Table

| Approach | Latency | Complexity | Risk |
|----------|---------|------------|------|
| In-place migration | Low | High | Medium |
| Blue-green deploy | Medium | Low | Low |
| Canary release | High | Medium | Low |

### Next Steps

- Bob to submit the auth PR by **Friday**
- Alice to run load tests on staging
- Team to review the [design doc](https://w.amazon.com/bin/view/Example)

> **Note:** The deploy freeze starts next Monday. All PRs must be merged by EOD Friday.

#### Risks

The ~~old session-based approach~~ has been deprecated. We need to migrate all clients before EOD next Friday.

---

Let me know if you need more details on any of these topics!`;

// mention/section are the only INTERNAL_CARD_TYPES, so unlike the samples above these
// render only for a reply attributed to the built-in agent.
export const sampleInternalCardsResponse = `Here's what I picked up while you were away:

\`\`\`section
{"type":"context","title":"Where things stand","content":[{"heading":"Auth migration","body":"Blue-green deploy approved; Bob owns the rollout."},{"heading":"Coverage","body":"Dropped to 87%, below the 90% gate."}]}
\`\`\`

\`\`\`mention
{"name":"Alice Chen","time":"2:14 PM","context":"asked whether you'd reviewed the budget proposal","detail":"Alice said the finance team needs your sign-off before Thursday, otherwise the Q3 headcount request slips a cycle."}
\`\`\`

\`\`\`section
{"type":"topics","title":"Topics covered","content":[{"heading":"Release timeline","body":"Code freeze Monday, prod deploy Wednesday."},{"heading":"On-call rotation","body":"Still unassigned for the holiday week."}]}
\`\`\`

\`\`\`mention
{"name":"Dev Patel","time":"2:31 PM","context":"volunteered you for the incident review","detail":"Dev suggested you walk through the auth timeout postmortem since you traced the original root cause."}
\`\`\`

\`\`\`section
{"type":"now","title":"Right now","content":"The team is wrapping up and asking for any final blockers."}
\`\`\`

Want me to draft a reply to Alice?`;

// One dismissible banner and no surrounding prose, so dismissing it should take the
// agent avatar, name, and feedback controls with it. Trailing text would leave a
// segment behind that keeps the message alive.
export const sampleLoneAlertBannerResponse = `\`\`\`alert_banner
{"message":"Deploy freeze starts tomorrow at 5PM PST","severity":"warning","dismissible":true}
\`\`\``;

// Two dismissible banners and nothing else: dismissing the first should leave the
// avatar (one card still visible), and dismissing the second should remove it.
export const sampleTwoAlertBannersResponse = `\`\`\`alert_banner
{"message":"First banner — dismiss me, the avatar should stay","severity":"info","dismissible":true}
\`\`\`

\`\`\`alert_banner
{"message":"Second banner — dismiss me too, now the avatar should go","severity":"warning","dismissible":true}
\`\`\``;

// Mock /available-extensions payload for localhost. Covers the shortName display cases:
// a normal name, a defaultDisplayName past the truncation budget, and a shortName whose
// first two chars collide with another agent's (same avatar initials).
export const sampleAvailableExtensions = [
  {
    extensionId: "ext-ops-agent",
    defaultDisplayName: "Ops Agent",
    shortName: "ops",
    enabled: true,
    canChat: true,
    invokePermission: "all",
  },
  {
    extensionId: "ext-insights-agent",
    defaultDisplayName: "Quarterly Revenue Insights and Forecasting Agent",
    shortName: "insights",
    enabled: true,
    canChat: true,
    invokePermission: "all",
  },
  {
    extensionId: "ext-notetaker-agent",
    defaultDisplayName: "Smart Notes",
    shortName: "opsnotes",
    enabled: false,
    canChat: true,
    invokePermission: "all",
  },
];

export const samplePublishedContent = [
  {
    extensionId: "ext-ops-agent",
    contentId: "ops-summary-1",
    displayName: "Ops Agent",
    shortName: "ops",
    visibility: "all",
    targetPanel: "assistant",
    content: "## Meeting Update\n\nHere's what happened in the last **15 minutes**:\n\n- Revenue discussion completed\n- Hiring plan approved\n\n```alert_banner\n{\"message\": \"Deployment to prod is blocked by failing tests\", \"severity\": \"warning\", \"dismissible\": true}\n```\n\n### Action Items\n\n```action_list\n{\"title\": \"Your Action Items\", \"items\": [{\"text\": \"Review budget proposal by Friday\", \"priority\": \"high\"}, {\"text\": \"Schedule 1:1 with new hire\", \"priority\": \"medium\"}]}\n```\n\n> Note: You were mentioned during the revenue discussion.",
    publishedAt: 1782520600000,
    updatedAt: 1782520637238,
    ttlSeconds: 250,
  },
  {
    extensionId: "ext-insights-agent",
    contentId: "insights-card-1",
    displayName: "Insights Agent",
    shortName: "insights",
    visibility: "all",
    targetPanel: "assistant",
    content: "```metric_card\n{\"title\":\"Meeting Health\",\"rows\":[{\"label\":\"Talk Time Balance\",\"value\":\"62/38%\",\"trend\":\"flat\"},{\"label\":\"Topics Covered\",\"value\":\"4/6\",\"trend\":\"up\"},{\"label\":\"Time Remaining\",\"value\":\"12 min\",\"trend\":\"down\"}],\"alert\":\"2 agenda items not yet discussed\"}\n```",
    publishedAt: 1782520620000,
    updatedAt: 1782520620000,
  },
  {
    extensionId: "ext-notetaker-agent",
    contentId: "notes-live-1",
    displayName: "Smart Notes",
    shortName: "notes",
    visibility: "all",
    targetPanel: "assistant",
    content: "### Live Notes\n\n**Decision:** Move forward with Option B (blue-green deploy) for the auth migration.\n\n**Context:** Team agreed the extra infra cost is justified given the zero-risk guarantee.\n\n```timeline\n{\"title\":\"Discussion Flow\",\"events\":[{\"time\":\"2:05 PM\",\"label\":\"Auth migration options\",\"status\":\"done\",\"description\":\"Compared in-place vs blue-green\"},{\"time\":\"2:15 PM\",\"label\":\"Cost analysis\",\"status\":\"done\",\"description\":\"$2k/mo extra for blue-green\"},{\"time\":\"2:22 PM\",\"label\":\"Decision made\",\"status\":\"active\",\"description\":\"Blue-green approved unanimously\"}]}\n```",
    publishedAt: 1782520650000,
    updatedAt: 1782520650000,
  },
];

// Sample action items for localhost dev — seeded into the insight store so the Action Items tab
// shows populated cards without a backend (localhost has no /action-items endpoint).
export const sampleActionItems = [
  {
    itemId: "sample-action-1",
    content: "Follow up with design on the new onboarding flow mockups",
    ownerName: "Priya Nair",
    deadline: "Aug 12",
    detectedAt: "2026-09-09T17:02:00.000Z",
    updatedAt: "2026-09-09T17:02:00.000Z",
    amendmentCount: 0,
  },
  {
    itemId: "sample-action-2",
    content: "Send the Q3 roadmap doc to the leadership channel for review",
    ownerName: null,
    deadline: null,
    detectedAt: "2026-09-09T17:05:00.000Z",
    updatedAt: "2026-09-09T17:05:00.000Z",
    amendmentCount: 0,
  },
  {
    itemId: "sample-action-3",
    content: "Investigate the latency spike in the summary generation pipeline",
    ownerName: "Marco Diaz",
    deadline: "Next sprint",
    detectedAt: "2026-09-09T17:08:00.000Z",
    updatedAt: "2026-09-09T17:08:00.000Z",
    amendmentCount: 0,
  },
];

// Sample agenda items for localhost dev — seeded into agendaItems state so the Agenda tab
// shows populated items without a backend (localhost has no /agenda endpoint).
// Built through makeAgendaItem so local-dev rows are structurally identical to fetched ones —
// hand-rolling the shape here is how local dev ends up exercising a row the app never really sees.
export const sampleAgendaItems = [
  makeAgendaItem({ id: "agenda#a1b2c3d4-0001-4000-8000-000000000001", title: "Welcome & intros", state: AGENDA_STATE.COMPLETED }),
  makeAgendaItem({
    id: "agenda#a1b2c3d4-0002-4000-8000-000000000002",
    title: "Longer agenda item to demonstrate how lines wrap and behave when we have larger text in this progress tracker.",
    state: AGENDA_STATE.IN_PROGRESS,
  }),
  makeAgendaItem({ id: "agenda#a1b2c3d4-0003-4000-8000-000000000003", title: "Budget planning for Q2", state: AGENDA_STATE.UPCOMING }),
  makeAgendaItem({ id: "agenda#a1b2c3d4-0004-4000-8000-000000000004", title: "Open discussion & next steps", state: AGENDA_STATE.UPCOMING }),
];